import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Flame, ArrowUpRight } from "lucide-react";
import api from "../lib/api";
import Reveal from "./Reveal";

export default function CommunityGallery() {
  const [photos, setPhotos] = useState(null);

  useEffect(() => {
    api.get("/lounge/gallery").then((r) => setPhotos(r.data)).catch(() => setPhotos([]));
  }, []);

  if (!photos || photos.length === 0) return null;

  return (
    <section data-testid="community-gallery" className="max-w-[1440px] mx-auto px-5 lg:px-10 py-24">
      <Reveal>
        <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-6 mb-12">
          <div>
            <p className="text-xs font-mono uppercase tracking-[0.3em] text-kinetic mb-4">From the community</p>
            <h2 className="font-display font-extrabold uppercase text-3xl sm:text-4xl lg:text-5xl tracking-tight">
              The Lounge, <span className="font-serif italic normal-case text-ash">in pictures</span>
            </h2>
          </div>
          <Link to="/lounge" data-testid="community-gallery-cta"
            className="group flex items-center gap-2 text-xs font-mono uppercase tracking-[0.2em] text-porcelain border border-white/15 hover:border-kinetic/60 px-6 py-3.5 rounded-full transition-colors duration-300 w-fit">
            Join the Lounge <ArrowUpRight size={14} className="text-kinetic group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform duration-300" />
          </Link>
        </div>
      </Reveal>
      <div className="grid grid-cols-2 lg:grid-cols-3 gap-4">
        {photos.map((p, i) => (
          <Reveal key={p.id} delay={Math.min(i, 5) * 0.06}>
            <a href={p.image_url} target="_blank" rel="noopener noreferrer" data-testid={`community-gallery-photo-${i}`}
              className="group relative block aspect-[4/3] overflow-hidden border border-white/10 hover:border-kinetic/50 transition-colors duration-300">
              <img src={p.image_url} alt={`Shared by ${p.author_name} in the Lounge`} loading="lazy"
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
              <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-obsidian/95 via-obsidian/40 to-transparent p-4 flex items-end justify-between gap-3">
                <span className="text-xs font-medium text-porcelain truncate">{p.author_name}</span>
                {(p.flames || 0) > 0 && (
                  <span className="flex items-center gap-1 text-[10px] font-mono text-kinetic shrink-0">
                    <Flame size={11} fill="currentColor" /> {p.flames}
                  </span>
                )}
              </div>
            </a>
          </Reveal>
        ))}
      </div>
    </section>
  );
}
